import { NMAppDataStore } from "@neumetric/blueprint-lib/store";
export * from "./risk";

const HOST_SERVER = process.env.REACT_APP_API_SERVER || "http://localhost:3000";
const store = new NMAppDataStore(HOST_SERVER);

export function createAppStore() {
  store.initAppState();
  store.initSessionState();
  store.initCommonState();
  return store.createStore();
}
